import { Close } from '@mui/icons-material'
import { Alert, Button, IconButton } from '@mui/material'

const PulseAlertMessage = ({ setAlert, setOpen, setSortType, alert }) => {
  return (
    <Alert
      severity='error'
      sx={{ margin: 1, mb: 1, mt: 0 }}
      onClick={() => {
        setOpen(true)
        setSortType('Yours')
      }}
      action={
        <>
          <Button
            variant='contained'
            sx={{ display: { md: 'block', xs: 'none' }, marginRight: 1 }}
            size='small'
            color='secondary'
          >
            View Your Response
          </Button>
          <IconButton
            size='small'
            color='inherit'
            onClick={e => {
              e.stopPropagation()
              setAlert(null)
            }}
          >
            <Close />
          </IconButton>
        </>
      }
    >
      {alert} <span>Click here to view your response.</span>
    </Alert>
  )
}

export default PulseAlertMessage
